import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { SingleImage } from "@/pages/admin/ImageManager";
import { AdminHeader } from "@/pages/admin/AdminLayout";
import { SpanishFields, cleanEs } from "@/pages/admin/SpanishFields";
import { ChangePassword } from "@/pages/admin/ChangePassword";
import { Switch } from "@/components/ui/switch";

const ES_FIELDS = [
  { key: "hero_title", label: "Titular de portada", type: "input" }, { key: "hero_subtitle", label: "Texto de portada", rows: 3 },
  { key: "broker_license", label: "Línea de licencia", type: "input" },
  { key: "topbar_text", label: "Barra superior: texto", type: "input" }, { key: "topbar_cta_label", label: "Barra superior: texto del botón", type: "input" },
];

const TEXT = [
  ["hero_title", "Homepage headline"], ["contact_name", "Contact name"], ["contact_email", "Contact email"],
  ["contact_whatsapp", "WhatsApp number (digits only, e.g. 50587085440)"], ["contact_phone_display", "Phone as displayed"],
  ["broker_license", "Broker license line"], ["instagram_url", "Instagram URL"], ["facebook_url", "Facebook URL"],
  ["google_verification", "Google Search Console code (only the content=\"…\" part)"],
  ["topbar_text", "Top bar text (left side)"], ["topbar_cta_label", "Top bar button text (leave empty to hide)"], ["topbar_cta_url", "Top bar button link (https://…)"],
];

export default function AdminSettings() {
  const [f, setF] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setF(r.data));
  }, []);
  if (!f) return <p className="text-moss">Loading…</p>;
  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/settings", { ...f, es: cleanEs(f.es) });
      toast.success("Settings saved");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };
  return (
    <>
    <form onSubmit={save} className="max-w-3xl" data-testid="admin-settings">
      <AdminHeader title="Site Settings"><button type="submit" className="btn-primary" data-testid="settings-save">Save settings</button></AdminHeader>
      <div className="space-y-5 rounded-2xl border border-clay bg-white p-6 sm:p-8">
        <div className="space-y-2"><Label className="font-bold">Homepage hero image</Label><SingleImage value={f.hero_image} onChange={(v) => setF({ ...f, hero_image: v })} testId="settings-hero-upload" /></div>
        <div className="space-y-2"><Label className="font-bold">About page photo of Blue</Label><SingleImage value={f.about_photo} onChange={(v) => setF({ ...f, about_photo: v })} testId="settings-about-photo-upload" /></div>
        <div className="space-y-2">
          <Label className="font-bold">Homepage intro text</Label>
          <Textarea rows={3} value={f.hero_subtitle} onChange={(e) => setF({ ...f, hero_subtitle: e.target.value })} data-testid="settings-hero_subtitle" />
        </div>
        <div className="grid gap-5 sm:grid-cols-2">
          {TEXT.map(([k, label]) => (
            <div key={k} className="space-y-2">
              <Label className="font-bold">{label}</Label>
              <Input value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`settings-${k}`} />
            </div>
          ))}
        </div>
        <label className="flex items-center gap-3 font-bold"><Switch checked={f.popular_badge !== false} onCheckedChange={(v) => setF({ ...f, popular_badge: v })} data-testid="settings-popular_badge" /> Show "Popular this week" tag on the most-viewed home and rental</label>
      </div>
      <div className="mt-6"><SpanishFields fields={ES_FIELDS} source={f} value={f.es || {}} onChange={(es) => setF({ ...f, es })} testId="settings-es" /></div>
    </form>
    <ChangePassword />
    </>
  );
}
